<template>
    <b-dropdown
        expanded
        aria-role="list"
        position="is-top-left"
      >
        <template #trigger>
          <b-button
            label="Settings"
            type="is-light is-stealth"
            expanded
            icon-left="cog"
            icon-right="menu-up"
          />
        </template>
        <b-dropdown-item
          aria-role="listitem"
          has-link
        >
          <router-link :to="{name: 'ImportBookmarks'}">
            Import
          </router-link>
        </b-dropdown-item>
        <b-dropdown-item
          aria-role="listitem"
          has-link
        >
          <router-link :to="{name: 'Export'}">
            Export
          </router-link>
        </b-dropdown-item>
        <b-dropdown-item
          aria-role="listitem"
          has-link
        >
          <router-link :to="{name: 'UserEdit', params: {id: user.id}}">
            Edit Account
          </router-link>
        </b-dropdown-item>
        <hr class="dropdown-divider">
        <b-dropdown-item
          aria-role="listitem"
          has-link
        >
          <router-link :to="{name: 'Logout'}">
            <b-icon
              pack="fas"
              icon="sign-out-alt"
              size="is-small"
            />
            Logout
          </router-link>
        </b-dropdown-item>
      </b-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },
}
</script>